import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-editar-vigilante',
  templateUrl: './modal-editar-vigilante.component.html',
  styleUrls: ['./modal-editar-vigilante.component.css']
})
export class ModalEditarVigilanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
